import { useEffect, useRef, useState } from "react"
import { useSearchParams as useSearchParamsRR } from "react-router-dom"

export const useSearchQueryProxy = ({
  initialState,
  useQueryString,
  onChangeCb
}: {
  initialState: Record<string, string>
  useQueryString: boolean
  onChangeCb?: (params: any) => void
}) => {
  const dirty = useRef(false)
  const [searchParamsRR, setSearchParamsRR] = useSearchParamsRR()
  const [searchParams, updateSearchParams] = useState(
    () => new URLSearchParams(initialState || searchParamsRR)
  )

  useEffect(() => {
    if (initialState) return

    updateSearchParams(() => new URLSearchParams(searchParamsRR))
  }, [searchParamsRR])

  const setSearchParams = (
    cb: (params: URLSearchParams) => URLSearchParams
  ) => {
    dirty.current = true
    updateSearchParams(new URLSearchParams(cb(searchParams)))
  }

  return [
    searchParams,
    setSearchParams,
    {
      isDirty: dirty.current,
      original: searchParamsRR,
      updateSearchParams: (
        params: URLSearchParams | ((params: URLSearchParams) => URLSearchParams)
      ) => {
        dirty.current = false

        if (!useQueryString && !!onChangeCb)
          onChangeCb(
            Object.fromEntries(
              typeof params === "function" ? params(searchParams) : params
            )
          )
        else setSearchParamsRR(params)
      }
    }
  ] as const
}
